import { render, staticRenderFns } from "./SelectStrategyImportFromFig.vue?vue&type=template&id=3c50ddfa&scoped=true"
import script from "./SelectStrategyImportFromFig.vue?vue&type=script&lang=js"
export * from "./SelectStrategyImportFromFig.vue?vue&type=script&lang=js"
import style0 from "./SelectStrategyImportFromFig.vue?vue&type=style&index=0&id=3c50ddfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c50ddfa",
  null
  
)

export default component.exports